import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, "任务执行详情  ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 展开任务配置 ")
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-left" }, null, -1)
const _hoisted_4 = { class: "test-header" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"mediumseagreen"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"#cc0000"}
}
const _hoisted_7 = {
  key: 2,
  style: {"color":"goldenrod"}
}
const _hoisted_8 = {
  key: 3,
  style: {"color":"blue"}
}
const _hoisted_9 = { key: 4 }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { class: "tabsCard" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"blue"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_14 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_15 = {
  key: 3,
  style: {"color":"#f57c00"}
}
const _hoisted_16 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_17 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_18 = {
  key: 0,
  style: {"color":"green","display":"flex","align-items":"center"}
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-check",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_20 = { style: {"font-size":"1.1rem"} }
const _hoisted_21 = {
  key: 1,
  style: {"color":"blue","display":"flex","align-items":"center"}
}
const _hoisted_22 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-refresh",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_23 = { style: {"font-size":"1.1rem"} }
const _hoisted_24 = {
  key: 2,
  style: {"color":"orange","display":"flex","align-items":"center"}
}
const _hoisted_25 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-time",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_26 = { style: {"font-size":"1.1rem"} }
const _hoisted_27 = {
  key: 3,
  style: {"color":"red","display":"flex","align-items":"center"}
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-close",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_29 = { style: {"font-size":"1.1rem"} }
const _hoisted_30 = {
  key: 0,
  style: {"color":"green","display":"flex","align-items":"center"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-check",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_32 = { style: {"font-size":"1.1rem"} }
const _hoisted_33 = {
  key: 1,
  style: {"color":"blue","display":"flex","align-items":"center"}
}
const _hoisted_34 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-refresh",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_35 = { style: {"font-size":"1.1rem"} }
const _hoisted_36 = {
  key: 2,
  style: {"color":"orange","display":"flex","align-items":"center"}
}
const _hoisted_37 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-time",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_38 = { style: {"font-size":"1.1rem"} }
const _hoisted_39 = {
  key: 3,
  style: {"color":"red","display":"flex","align-items":"center"}
}
const _hoisted_40 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-close",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_41 = { style: {"font-size":"1.1rem"} }
const _hoisted_42 = {
  key: 0,
  style: {"color":"green","display":"flex","align-items":"center"}
}
const _hoisted_43 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-check",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_44 = { style: {"font-size":"1.1rem"} }
const _hoisted_45 = {
  key: 1,
  style: {"color":"blue","display":"flex","align-items":"center"}
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-refresh",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_47 = { style: {"font-size":"1.1rem"} }
const _hoisted_48 = {
  key: 2,
  style: {"color":"orange","display":"flex","align-items":"center"}
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-time",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_50 = { style: {"font-size":"1.1rem"} }
const _hoisted_51 = {
  key: 3,
  style: {"color":"red","display":"flex","align-items":"center"}
}
const _hoisted_52 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-close",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_53 = { style: {"font-size":"1.1rem"} }
const _hoisted_54 = {
  key: 0,
  style: {"color":"green","display":"flex","align-items":"center"}
}
const _hoisted_55 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-check",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_56 = { style: {"font-size":"1.1rem"} }
const _hoisted_57 = {
  key: 1,
  style: {"color":"blue","display":"flex","align-items":"center"}
}
const _hoisted_58 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-refresh",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_59 = { style: {"font-size":"1.1rem"} }
const _hoisted_60 = {
  key: 2,
  style: {"color":"orange","display":"flex","align-items":"center"}
}
const _hoisted_61 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-time",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_62 = { style: {"font-size":"1.1rem"} }
const _hoisted_63 = {
  key: 3,
  style: {"color":"red","display":"flex","align-items":"center"}
}
const _hoisted_64 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-close",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_65 = { style: {"font-size":"1.1rem"} }
const _hoisted_66 = {
  key: 0,
  style: {"color":"green","display":"flex","align-items":"center"}
}
const _hoisted_67 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-check",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_68 = { style: {"font-size":"1.1rem"} }
const _hoisted_69 = {
  key: 1,
  style: {"color":"blue","display":"flex","align-items":"center"}
}
const _hoisted_70 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-refresh",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_71 = { style: {"font-size":"1.1rem"} }
const _hoisted_72 = {
  key: 2,
  style: {"color":"orange","display":"flex","align-items":"center"}
}
const _hoisted_73 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-time",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_74 = { style: {"font-size":"1.1rem"} }
const _hoisted_75 = {
  key: 3,
  style: {"color":"red","display":"flex","align-items":"center"}
}
const _hoisted_76 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-circle-close",
  style: {"font-size":"1.4rem"}
}, null, -1)
const _hoisted_77 = { style: {"font-size":"1.1rem"} }
const _hoisted_78 = /*#__PURE__*/_createTextVNode("链接")
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = /*#__PURE__*/_createVNode("b", null, "版本:", -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode("链接")
const _hoisted_83 = { key: 1 }
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_header = _resolveComponent("el-header")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { style: {"line-height":"60px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between",
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 20,
                    style: {"font-size":"1.5rem","font-weight":"bold","display":"flex","align-items":"center"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_el_button, {
                        style: "",
                        type: "primary",
                        icon: "el-icon-refresh",
                        circle: "",
                        size: "small",
                        onClick: _ctx.refreshTaskRecord
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 4,
                    style: {"text-align":"right"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _withDirectives(_createVNode(_component_el_table, {
                      data: _ctx.taskRecordTable,
                      "header-cell-class-name": "tabelHeader"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "status",
                          label: "执行状态"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.status === '完成')
                              ? (_openBlock(), _createBlock("span", _hoisted_5, [
                                  _createVNode("b", null, _toDisplayString(scope.row.status), 1)
                                ]))
                              : (
                      scope.row.status === '取消' || scope.row.status === '异常'
                    )
                                ? (_openBlock(), _createBlock("span", _hoisted_6, [
                                    _createVNode("b", null, _toDisplayString(scope.row.status), 1)
                                  ]))
                                : (scope.row.status === '暂停')
                                  ? (_openBlock(), _createBlock("span", _hoisted_7, [
                                      _createVNode("b", null, _toDisplayString(scope.row.status), 1)
                                    ]))
                                  : (scope.row.status === '进行中')
                                    ? (_openBlock(), _createBlock("span", _hoisted_8, [
                                        _createVNode("b", null, _toDisplayString(scope.row.status), 1)
                                      ]))
                                    : (_openBlock(), _createBlock("span", _hoisted_9, [
                                        _createVNode("b", null, _toDisplayString(scope.row.status), 1)
                                      ]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "task_name",
                          label: "任务名"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "create_user",
                          label: "执行人"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "start_date",
                          label: "开始时间"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "end_date",
                          label: "结束时间"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]), [
                      [_directive_loading, _ctx.loading]
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_el_tabs, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeName = $event))
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_el_tab_pane, {
                      label: "执行状态",
                      name: "first"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, { class: "subCard stateTable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table, {
                              "header-cell-class-name": "tabelHeader",
                              "span-method": _ctx.taskGroupSpanMethod,
                              data: _ctx.setTaskGroupTable
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "scene",
                                  label: "场景"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "status",
                                  label: "状态"
                                }, {
                                  default: _withCtx((scope) => [
                                    (scope.row.status === 1)
                                      ? (_openBlock(), _createBlock("span", _hoisted_12, "进行中"))
                                      : (scope.row.status === 3)
                                        ? (_openBlock(), _createBlock("span", _hoisted_13, "已完成"))
                                        : (scope.row.status === 5)
                                          ? (_openBlock(), _createBlock("span", _hoisted_14, "异常"))
                                          : (scope.row.status === 0)
                                            ? (_openBlock(), _createBlock("span", _hoisted_15, "等待"))
                                            : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "device_id",
                                  label: "设备",
                                  width: "200"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_el_popover, {
                                      effect: "light",
                                      trigger: "hover",
                                      placement: "top",
                                      width: 250
                                    }, {
                                      default: _withCtx(() => [
                                        (scope.row.device_level !== '-')
                                          ? (_openBlock(), _createBlock("p", _hoisted_16, _toDisplayString(scope.row.device_id +
                              " - " +
                              (scope.row.device_level + 1) +
                              "档机"), 1))
                                          : (_openBlock(), _createBlock("p", _hoisted_17, "-"))
                                      ]),
                                      reference: _withCtx(() => [
                                        _createVNode("div", null, [
                                          _createVNode(_component_el_tag, { size: "medium" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(scope.row.device_remark +
                                " - " +
                                scope.row.device_specs_name), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "scripts",
                                  label: "局内脚本"
                                }),
                                _createVNode(_component_el_table_column, { label: "运行阶段" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      prop: "start",
                                      label: "任务接收",
                                      "min-width": 120
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          content: scope.row.startMsg,
                                          placement: "top",
                                          disabled: !scope.row.startMsg
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode("div", null, [
                                              (scope.row.start === 'done')
                                                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                                                    _hoisted_19,
                                                    _createVNode("span", _hoisted_20, _toDisplayString(scope.row.start_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.start === 'running')
                                                ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                                    _hoisted_22,
                                                    _createVNode("span", _hoisted_23, _toDisplayString(scope.row.start_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.start === 'wait')
                                                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                                                    _hoisted_25,
                                                    _createVNode("span", _hoisted_26, _toDisplayString(scope.row.start_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.start === 'error')
                                                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                                    _hoisted_28,
                                                    _createVNode("span", _hoisted_29, _toDisplayString(scope.row.start_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["content", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "download",
                                      label: "安装",
                                      "min-width": 120
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          content: scope.row.downloadMsg,
                                          placement: "top",
                                          disabled: !scope.row.downloadMsg
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode("div", null, [
                                              (scope.row.download === 'done')
                                                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                                                    _hoisted_31,
                                                    _createVNode("span", _hoisted_32, _toDisplayString(scope.row.download_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.download === 'running')
                                                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                                                    _hoisted_34,
                                                    _createVNode("span", _hoisted_35, _toDisplayString(scope.row.download_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.download === 'wait')
                                                ? (_openBlock(), _createBlock("div", _hoisted_36, [
                                                    _hoisted_37,
                                                    _createVNode("span", _hoisted_38, _toDisplayString(scope.row.download_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.download === 'error')
                                                ? (_openBlock(), _createBlock("div", _hoisted_39, [
                                                    _hoisted_40,
                                                    _createVNode("span", _hoisted_41, _toDisplayString(scope.row.download_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["content", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "login",
                                      label: "登陆",
                                      "min-width": 120
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          content: scope.row.loginMsg,
                                          placement: "top",
                                          disabled: !scope.row.loginMsg
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode("div", null, [
                                              (scope.row.login === 'done')
                                                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                                    _hoisted_43,
                                                    _createVNode("span", _hoisted_44, _toDisplayString(scope.row.login_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.login === 'running')
                                                ? (_openBlock(), _createBlock("div", _hoisted_45, [
                                                    _hoisted_46,
                                                    _createVNode("span", _hoisted_47, _toDisplayString(scope.row.login_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.login === 'wait')
                                                ? (_openBlock(), _createBlock("div", _hoisted_48, [
                                                    _hoisted_49,
                                                    _createVNode("span", _hoisted_50, _toDisplayString(scope.row.login_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.login === 'error')
                                                ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                                    _hoisted_52,
                                                    _createVNode("span", _hoisted_53, _toDisplayString(scope.row.login_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["content", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "enterScene",
                                      label: "进入场景",
                                      "min-width": 120
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          content: scope.row.enterSceneMsg,
                                          placement: "top",
                                          disabled: !scope.row.enterSceneMsg
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode("div", null, [
                                              (scope.row.enterScene === 'done')
                                                ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                                    _hoisted_55,
                                                    _createVNode("span", _hoisted_56, _toDisplayString(scope.row.enter_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.enterScene === 'running')
                                                ? (_openBlock(), _createBlock("div", _hoisted_57, [
                                                    _hoisted_58,
                                                    _createVNode("span", _hoisted_59, _toDisplayString(scope.row.enter_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.enterScene === 'wait')
                                                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                                    _hoisted_61,
                                                    _createVNode("span", _hoisted_62, _toDisplayString(scope.row.enter_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.enterScene === 'error')
                                                ? (_openBlock(), _createBlock("div", _hoisted_63, [
                                                    _hoisted_64,
                                                    _createVNode("span", _hoisted_65, _toDisplayString(scope.row.enter_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["content", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "InScene",
                                      label: "场景执行",
                                      "min-width": 120
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          content: scope.row.inSceneMsg,
                                          placement: "top",
                                          disabled: !scope.row.inSceneMsg
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode("div", null, [
                                              (scope.row.inScene === 'done')
                                                ? (_openBlock(), _createBlock("div", _hoisted_66, [
                                                    _hoisted_67,
                                                    _createVNode("span", _hoisted_68, _toDisplayString(scope.row.in_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.inScene === 'running')
                                                ? (_openBlock(), _createBlock("div", _hoisted_69, [
                                                    _hoisted_70,
                                                    _createVNode("span", _hoisted_71, _toDisplayString(scope.row.in_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.inScene === 'wait')
                                                ? (_openBlock(), _createBlock("div", _hoisted_72, [
                                                    _hoisted_73,
                                                    _createVNode("span", _hoisted_74, _toDisplayString(scope.row.in_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (scope.row.inScene === 'error')
                                                ? (_openBlock(), _createBlock("div", _hoisted_75, [
                                                    _hoisted_76,
                                                    _createVNode("span", _hoisted_77, _toDisplayString(scope.row.in_scene_timer), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["content", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "start_time",
                                  label: "开始时间",
                                  width: "170"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "end_time",
                                  label: "结束时间",
                                  width: "170"
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "链接",
                                  prop: "url",
                                  width: "85"
                                }, {
                                  default: _withCtx((scope) => [
                                    (scope.row.url && scope.row.url !== '-')
                                      ? (_openBlock(), _createBlock(_component_el_link, {
                                          key: 0,
                                          href: _ctx.get_url(scope.row.url),
                                          type: "primary",
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_78
                                          ]),
                                          _: 2
                                        }, 1032, ["href"]))
                                      : (_openBlock(), _createBlock("span", _hoisted_79, _toDisplayString(scope.row.url), 1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["span-method", "data"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _withDirectives(_createVNode(_component_el_tab_pane, {
                      label: "客户端性能数据",
                      name: "second"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, { class: "subCard" }, {
                          default: _withCtx(() => [
                            (_ctx.get_version)
                              ? (_openBlock(), _createBlock("span", _hoisted_80, [
                                  _hoisted_81,
                                  _createTextVNode(" " + _toDisplayString(_ctx.get_version), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_table, {
                              data: _ctx.get_table_data,
                              style: {"width":"100%"},
                              "header-cell-style": {
                    background: '#eef1f6',
                    color: '#606266',
                  },
                              size: "mini",
                              "span-method": _ctx.performanceSpanMethod,
                              "header-cell-class-name": "tabelHeader"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.performance_table_fields, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: item.prop,
                                    label: item.label,
                                    prop: item.prop,
                                    "min-width": item.prop == '卡顿详情' ? 500 : 80
                                  }, null, 8, ["label", "prop", "min-width"]))
                                }), 128)),
                                _createVNode(_component_el_table_column, {
                                  label: "详情",
                                  prop: "url",
                                  width: "85",
                                  fixed: "right"
                                }, {
                                  default: _withCtx((scope) => [
                                    (scope.row.url && scope.row.url !== '-')
                                      ? (_openBlock(), _createBlock(_component_el_link, {
                                          key: 0,
                                          href: _ctx.get_url(scope.row.url),
                                          type: "primary",
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_82
                                          ]),
                                          _: 2
                                        }, 1032, ["href"]))
                                      : (_openBlock(), _createBlock("span", _hoisted_83, _toDisplayString(scope.row.url), 1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "数据下载",
                                  prop: "url",
                                  width: "85",
                                  fixed: "right"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode("a", {
                                      style: {"color":"#409eff","cursor":"pointer"},
                                      onClick: ($event: any) => (
                          _ctx.downloading(
                            scope.row.id,
                            scope.row.custom_data,
                            scope.row.scene_chinese
                          )
                        ),
                                      id: scope.row.id,
                                      type: "primary"
                                    }, "下载", 8, ["onClick", "id"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data", "span-method"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode(_component_el_tab_pane, {
                      label: "日志下载",
                      name: "third"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, { class: "subCard" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table, {
                              data: _ctx.get_logs,
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  prop: "file_name",
                                  label: "文件名"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_el_tag, {
                                      type: "info",
                                      size: "medium",
                                      effect: "plain"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_84,
                                        _createTextVNode(" " + _toDisplayString(scope.row.file_name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "time",
                                  label: "上传时间"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "file_path",
                                  label: "下载"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode("a", {
                                      href: scope.row.file_path,
                                      class: "ml-3",
                                      download: "",
                                      style: {"color":"#409eff","cursor":"pointer"}
                                    }, " 下载 ", 8, ["href"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}